import PropTypes from "prop-types";
import React from "react";

import { Button } from "@/component-library/Button";
import { Card } from "@/component-library/Card";
import { cn } from "@/lib/helpers/cn";
import { Text } from "@/component-library/Text";

import "./OnDemandWelcomeEmailSuccess.styles.scss";

export const OnDemandWelcomeEmailSuccess = ({ buttonClick, className }) => {
  return (
    <Card className={cn("apti-OnDemandWelcomeEmailSuccess", className)}>
      <div className="text-center">
        <Text className="apti-OnDemandWelcomeEmailSuccess--title" color="black">
          Success!
        </Text>
      </div>
      <div className="text-center p-4">
        <Text className="apti-OnDemandWelcomeEmailSuccess--sub-title">
          The welcome email has been resent. Please instruct the member to check their inbox and
          complete registration.
        </Text>
      </div>
      <div className="d-flex align-items-center px-5 pb-4 pt-2 tw:justify-center">
        <Button className="primary apti-TwoButtonCard-button-center" onClick={buttonClick}>
          OK
        </Button>
      </div>
    </Card>
  );
};

OnDemandWelcomeEmailSuccess.propTypes = {
  buttonClick: PropTypes.func,
  className: PropTypes.string,
};

OnDemandWelcomeEmailSuccess.defaultProps = {
  buttonClick: () => {},
  className: undefined,
};
